import React from "react";
import PropTypes from "prop-types";
import I18n from "i18n-js";

GenericLoadingError.propTypes = {
  message: PropTypes.string,
};

export default function GenericLoadingError({ message = null }) {
  return (
    <p className="text-danger">{message || I18n.t("common.loadingApiError")}</p>
  );
}
